var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "health-dashboard" },
    [
      _c(
        "div",
        { staticClass: "dashboard-left" },
        [
          _c("HealthChart", {
            key: "diet-chart",
            ref: "dietChart",
            attrs: {
              title: "饮食记录",
              "chart-type": "bar",
              "view-type": _vm.dietType,
              "day-data": _vm.dietDayData,
              "primary-color": _vm.dietColors.primary,
              "secondary-color": _vm.dietColors.secondary,
              "bar-color": _vm.dietColors.bar,
              "icon-bg-color": _vm.dietColors.iconBg,
              "chart-data": _vm.dietData,
              "x-axis-data": _vm.dietXAxisData,
              "show-charts": _vm.foodShow,
              "y-axis-max": 4,
              "chart-height": "200px",
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("diet", tab) },
          }),
          _c("HealthChart", {
            key: "sport-chart",
            ref: "sportChart",
            attrs: {
              title: "运动记录",
              "chart-type": "bar",
              "view-type": _vm.sportType,
              "day-data": _vm.sportDayData,
              "primary-color": _vm.sportColors.primary,
              "secondary-color": _vm.sportColors.secondary,
              "bar-color": _vm.sportColors.bar,
              "icon-bg-color": _vm.sportColors.iconBg,
              "chart-data": _vm.sportData,
              "x-axis-data": _vm.sportXAxisData,
              "stats-value": _vm.sportStats.totalCount,
              "stats-label": _vm.currentSportStatsLabel,
              "icon-class": "el-icon-s-promotion",
              "show-stats": true,
              "y-axis-max": 4,
              "show-label": false,
              "show-charts": _vm.sportShow,
              "chart-height": "220px",
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("sport", tab) },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function () {
                  return [
                    _c("i", { staticClass: "sport-icon" }, [_vm._v("🏃")]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("HealthChart", {
            key: "sleep-chart",
            ref: "sleepChart",
            attrs: {
              title: "睡眠记录",
              "chart-type": "line",
              "view-type": _vm.sleepType,
              "day-data": _vm.sleepDayData,
              "primary-color": _vm.sleepColors.primary,
              "secondary-color": _vm.sleepColors.secondary,
              "bar-color": _vm.sleepColors.bar,
              "icon-bg-color": _vm.sleepColors.iconBg,
              "chart-data": _vm.sleepData,
              "x-axis-data": _vm.sleepXAxisData,
              "y-axis-max": 12,
              "area-opacity": 0.25,
              "show-charts": _vm.sleepShow,
              "chart-height": "200px",
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("sleep", tab) },
          }),
          _c("HealthChart", {
            key: "massage-chart",
            ref: "massageChart",
            attrs: {
              title: "按摩记录",
              "chart-type": "line",
              "view-type": _vm.massageType,
              "day-data": _vm.massageDayData,
              "primary-color": _vm.massageColors.primary,
              "secondary-color": _vm.massageColors.secondary,
              "bar-color": _vm.massageColors.bar,
              "icon-bg-color": _vm.massageColors.iconBg,
              "chart-data": _vm.massageData,
              "x-axis-data": _vm.massageXAxisData,
              "stats-value": _vm.massageStats.totalCount,
              "stats-label": _vm.currentMassageStatsLabel,
              "show-stats": true,
              "y-axis-max": 8,
              "show-label": false,
              "area-opacity": 0.3,
              "show-charts": _vm.massageShow,
              "chart-height": "200px",
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("massage", tab) },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function () {
                  return [
                    _c("i", { staticClass: "massage-icon" }, [_vm._v("💆")]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "digital-human-section" }, [
        _c(
          "div",
          {
            staticClass: "points-badge",
            attrs: { title: "点击查看积分明细" },
            on: { click: _vm.openPointsDialog },
          },
          [
            _c("span", { staticClass: "points-value" }, [
              _vm._v(_vm._s(_vm.countIntegral)),
            ]),
            _c("span", { staticClass: "points-label" }, [_vm._v("积分")]),
          ]
        ),
        _c("div", { staticClass: "digital-human-container" }, [
          _vm.sexsign !== 1
            ? _c("img", {
                staticClass: "digital-human-img",
                attrs: {
                  src: require("@/assets/icon/numwuman.png"),
                  alt: "数字人",
                },
              })
            : _vm._e(),
          _vm.sexsign === 1
            ? _c("img", {
                staticClass: "digital-human-img",
                attrs: {
                  src: require("@/assets/icon/numman.png"),
                  alt: "数字人",
                },
              })
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            staticClass: "chat-bubble",
            on: { click: _vm.viewConstitutionReport },
          },
          [
            _c("div", { staticClass: "bubble-arrow" }),
            _c("p", { staticClass: "bubble-text" }, [
              _vm._v(
                "我是" + _vm._s(_vm.tizhi.name) + "，请点击查看我的体质报告"
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "标记漏服原因",
            visible: _vm.missedReasonDialogVisible,
            width: "400px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.missedReasonDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "missed-reason-content" },
            [
              _c("p", { staticClass: "reason-tip" }, [
                _vm._v("请选择今日未服用药物的原因："),
              ]),
              _c(
                "el-radio-group",
                {
                  staticClass: "reason-group",
                  model: {
                    value: _vm.selectedMissedReason,
                    callback: function ($$v) {
                      _vm.selectedMissedReason = $$v
                    },
                    expression: "selectedMissedReason",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "forgot" } }, [
                    _vm._v("忘记服用"),
                  ]),
                  _c("el-radio", { attrs: { label: "side_effect" } }, [
                    _vm._v("出现副作用"),
                  ]),
                  _c("el-radio", { attrs: { label: "not_available" } }, [
                    _vm._v("药物不在身边"),
                  ]),
                  _c("el-radio", { attrs: { label: "feel_better" } }, [
                    _vm._v("感觉好转自行停药"),
                  ]),
                  _c("el-radio", { attrs: { label: "other" } }, [
                    _vm._v("其他原因"),
                  ]),
                ],
                1
              ),
              _vm.selectedMissedReason === "other"
                ? _c("el-input", {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { placeholder: "请输入其他原因" },
                    model: {
                      value: _vm.otherReasonText,
                      callback: function ($$v) {
                        _vm.otherReasonText = $$v
                      },
                      expression: "otherReasonText",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.missedReasonDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmMissedReason },
                },
                [_vm._v("确认标记")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "体质报告",
            visible: _vm.dialogVisible,
            width: "600px",
            "close-on-click-modal": true,
            "custom-class": "constitution-dialog",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", {
            staticClass: "constitution-content",
            domProps: { innerHTML: _vm._s(_vm.constitutionContent) },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "积分明细",
            visible: _vm.pointsDialogVisible,
            width: "600px",
            "close-on-click-modal": true,
            "custom-class": "points-dialog",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pointsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "points-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: !_vm.countIntegralList.length,
                      expression: "!countIntegralList.length",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.countIntegralList,
                    stripe: "",
                    height: "250px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pointsLogDesc",
                      label: "事件",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "integralChange",
                      label: "积分变动",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  scope.row.integralChange >= 0
                                    ? "points-plus"
                                    : "points-minus",
                              },
                              [_vm._v(_vm._s(scope.row.integralChange))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next, total",
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  total: _vm.totalCount,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPage = $event
                  },
                  "current-change": _vm.handlePointsPageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.pointsDialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }